import React from "react";
import { AlertTriangle, RefreshCw, Download } from "lucide-react";
import { crashLogger } from "../lib/crash-logger";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    const isChunkError =
      error?.name === 'ChunkLoadError' ||
      error?.message?.includes('Loading chunk') ||
      error?.message?.includes('Failed to fetch dynamically imported module');

    if (isChunkError) {
      if (!sessionStorage.getItem('keves_chunk_reload')) {
        sessionStorage.setItem('keves_chunk_reload', '1');
        window.location.reload();
        return { hasError: false, error: null };
      }
      return { hasError: true, error, isChunkError: true };
    }

    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    crashLogger.crash(error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      const { fullScreen = true } = this.props;
      const { isChunkError } = this.state;
      return (
        <div className={`${fullScreen ? 'min-h-[80vh]' : 'py-8'} w-full flex flex-col items-center justify-center p-4 text-center`}>
          <div className="bg-white dark:bg-slate-800 p-6 rounded-[20px] shadow-sm border border-slate-100 dark:border-slate-700/50 max-w-sm w-full space-y-5">
            <div className={`h-14 w-14 ${isChunkError ? 'bg-blue-100 text-blue-600' : 'bg-red-100 text-red-600'} rounded-full flex items-center justify-center mx-auto`}>
              {isChunkError ? <Download className="h-7 w-7" /> : <AlertTriangle className="h-7 w-7" />}
            </div>
            <div className="space-y-2">
              <h2 className="text-xl font-semibold text-slate-800">
                {isChunkError ? "Nueva versión disponible" : "Ups, algo salió mal"}
              </h2>
              <p className="text-sm text-slate-500">
                {isChunkError
                  ? "La app se actualizó. Recarga para continuar con la versión más reciente."
                  : "La aplicación encontró un error inesperado al mostrar esta pantalla."}
              </p>
            </div>
          <div className="space-y-3 w-full">
            <button
              onClick={this.handleReset}
              className="w-full flex items-center justify-center gap-2 bg-brand hover:brightness-105 text-white font-semibold px-5 py-3 rounded-icon shadow-blue dark:shadow-none transition-all duration-200 ease-out active:scale-[0.98]"
            >
              <RefreshCw className="h-4 w-4" /> Intentar de nuevo
            </button>
            <button
              onClick={() => { this.setState({ hasError: false, error: null }); window.location.href = '/'; }}
              className="w-full flex items-center justify-center gap-2 bg-slate-100 hover:bg-slate-200 text-slate-700 font-semibold px-5 py-3 rounded-[14px] transition-all duration-200 ease-out active:scale-[0.98]"
            >
              Volver al inicio
            </button>
          </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}